import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import CheckIn from "@/pages/CheckIn";
import Wheel from "@/pages/Wheel";
import Toolkit from "@/pages/Toolkit";
import Goals from "@/pages/Goals";
import Companion from "@/pages/Companion";
import Surveys from "@/pages/Surveys";
import Profile from "@/pages/Profile";
import Report from "@/pages/Report";
import AppLayout from "@/components/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarded && window.location.pathname !== "/onboarding")
    return <Navigate to="/onboarding" replace />;
  return children;
}

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center whenua-gradient">
      <div className="font-serif text-2xl text-charcoal/70 italic">whiria…</div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
            <Route element={<Protected><AppLayout /></Protected>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/checkin" element={<CheckIn />} />
              <Route path="/wheel" element={<Wheel />} />
              <Route path="/toolkit" element={<Toolkit />} />
              <Route path="/goals" element={<Goals />} />
              <Route path="/companion" element={<Companion />} />
              <Route path="/surveys" element={<Surveys />} />
              <Route path="/surveys/:surveyId" element={<Surveys />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/report" element={<Report />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
